 const baseUrl = 'https://api.themoviedb.org/3/movie';
 const apiKey = '08142d9351171e224683a4c8cfe1c85f';
 const baseImgUrl = 'https://image.tmdb.org/t/p/original';

module.exports = {
    baseUrl,
    apiKey,
    baseImgUrl
};